export default __webpack_public_path__ + "static/media/luxluz.69eee42c.png";